// src/componentsBlock/Contract.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../api/universalApi";

const Contract = () => {
  const useLocation = () => {
    const { pathname } = window.location;
    const pathParts = pathname.split("/");
    return {
      pathname,
      campaignId: pathParts[pathParts.length - 1],
    };
  };
  const location = useLocation();
  // console.log("Location:", location.campaignId);
  const campaignId = location.campaignId;

  const [formData, setFormData] = useState({
    campaignId: campaignId || "",
    publishDate: "",
    amount: "",
    company: "",
    deliverables: "",
    paymentType: "",
    startDate: "",
    endDate: "",
    creatorSignature: "",
    repSignature: "",
    repEmail: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    console.log("Form Data:", formData);

    try {
      const res = await fetch(`${baseUrl}/api/agreement/createAgreement`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Submission failed");
      setSuccess(true);
      setFormData({
        campaignId: campaignId || "",
        publishDate: "",
        amount: "",
        company: "",
        deliverables: "",
        paymentType: "",
        startDate: "",
        endDate: "",
        creatorSignature: "",
        repSignature: "",
        repEmail: "",
      });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div
      className="w-full mx-auto mt-3 p-3 bg-white rounded shadow animate-fadeIn"
      style={{ fontFamily: "Gilroy-Medium" }}
    >
      <h2 className="text-2xl font-bold mb-1">Contract Details</h2>
      <p className="text-gray-500 mb-6">
        This is how others will see you on the site.
      </p>

      <form
        onSubmit={handleSubmit}
        className="space-y-3 w-full flex flex-col justify-start items-start bg-gray-200 p-4 rounded"
      >
        {/* Group 1 */}
        <div className="w-full flex flex-wrap gap-3 justify-start">
          <div className="w-full flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="publishDate"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              Publish Date
            </label>
            <input
              id="publishDate"
              name="publishDate"
              border
              border-gray-300
              type="date"
              value={formData.publishDate}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="MM/DD/YYYY"
            />
          </div>
          <div className="w-full flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="amount"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              Final Amount
            </label>
            <input
              id="amount"
              name="amount"
              type="text"
              value={formData.amount}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter Final Amount"
            />
          </div>
        </div>

        {/* Group 2 */}
        <div className="w-full flex flex-wrap gap-3 justify-start">
          <div className="w-full flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="company"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              Company Name
            </label>
            <input
              id="company"
              name="company"
              type="text"
              value={formData.company}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Company Name"
            />
          </div>
          <div className="flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="deliverables"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              Collaterals/Deliverables
            </label>
            <textarea
              id="deliverables"
              name="deliverables"
              value={formData.deliverables}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Collaterals/Deliverables"
            />
          </div>
        </div>

        {/* Payment Type */}
        <div className="flex flex-col md:flex-row md:items-center gap-3 justify-start">
          <label className="text-sm font-medium text-gray-700 w-full md:w-[48%] text-left">
            Payment Type
          </label>
          <div className=" flex flex-row items-center space-x-4">
            {["Upfront", "Partial", "Post"].map((type) => (
              <label
                key={type}
                className="inline-flex items-center justify-center"
              >
                <div>
                  <input
                    type="radio"
                    name="paymentType"
                    value={type}
                    checked={formData.paymentType === type}
                    onChange={handleChange}
                    className="form-radio text-blue-600"
                  />
                </div>
                <div>
                  <span className="ml-2">{type}</span>
                </div>
              </label>
            ))}
          </div>
        </div>

        {/* Dates */}
        <div className="w-full flex flex-wrap gap-6 justify-start">
          <div className="w-full flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="startDate"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              Start Date
            </label>
            <input
              id="startDate"
              name="startDate"
              type="date"
              value={formData.startDate}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-400 mt-1 text-left">
              Pick the starting date of the campaign
            </p>
          </div>
          <div className="w-full flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="endDate"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              End Date
            </label>
            <input
              id="endDate"
              name="endDate"
              type="date"
              value={formData.endDate}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-400 mt-1 text-left">
              Pick the end date of the campaign
            </p>
          </div>
        </div>

        {/* Signatures */}
        <div className="w-full flex flex-col justify-start items-start bg-gray-200  rounded">
          <h3 className="text-lg font-semibold mt-6">Signatures</h3>
          <p className="text-gray-500 mb-4 text-sm">
            This is how others will see you on the site.
          </p>

          <div className="w-full flex flex-row gap-3 justify-start">
            <div className="flex flex-col w-full md:w-[48%]">
              <label
                htmlFor="creatorSignature"
                className="mb-1 text-sm font-medium text-gray-700 text-left"
              >
                Creator Signature
              </label>
              <input
                id="creatorSignature"
                name="creatorSignature"
                type="text"
                value={formData.creatorSignature}
                onChange={handleChange}
                required
                className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Creator Signature"
              />
            </div>
            <div className="flex flex-col w-full md:w-[48%]">
              <label
                htmlFor="repSignature"
                className="mb-1 text-sm font-medium text-gray-700 text-left"
              >
                Brand Representative Signature
              </label>
              <input
                id="repSignature"
                name="repSignature"
                type="text"
                value={formData.repSignature}
                onChange={handleChange}
                required
                className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Brand Representative Signature"
              />
            </div>
          </div>
          <div className="mt-4 flex flex-col w-full md:w-[48%]">
            <label
              htmlFor="repEmail"
              className="mb-1 text-sm font-medium text-gray-700 text-left"
            >
              Brand Representative Email
            </label>
            <input
              id="repEmail"
              name="repEmail"
              type="email"
              value={formData.repEmail}
              onChange={handleChange}
              required
              className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Brand Representative Email"
            />
          </div>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="mt-6 bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition-all duration-200 ease-in-out"
        >
          Generate Contract
        </button>

        {/* Messages */}
        {error && <p className="text-red-600">{error}</p>}
        {success && (
          <p className="text-green-600">Contract generated successfully!</p>
        )}
      </form>
    </div>
  );
};

export default Contract;
